/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.filas': 'Filas',
  'filas.agregarFilas': 'Crear Filas',
  'filas.modificarFilas': 'Editar Filas',
  'filas.filaId': 'Fila Id',
  'filas.empresaId': 'Empresa Id',
  'filas.descripcionFila': 'Descripción Fila',
  'filas.VerFilas': 'Ver Filas',
  'filas.RegistroDuplicado': 'Registro Duplicado',
};
